<template>
  <div>
    <Card>
      <template slot="header">Invoice Source Report</template>
      <v-layout justify-center>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="update()"
        >
          <v-text-field
            slot="activator"
            v-model="dateRange.startDate"
            label="Start Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="dateRange.startDate"/>
        </v-menu>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="update()"
        >
          <v-text-field
            slot="activator"
            v-model="dateRange.endDate"
            label="End Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="dateRange.endDate"/>
        </v-menu>
      </v-layout>
    </Card>
    <v-card>
      <v-card-title>
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="invoiceSourceReport"
        :search="search"
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.invoiceSourceID }}</td>
          <td>{{ props.item.total }}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Invoice Source',
          value: 'invoiceSourceID',
          sortable: true
        },
        {
          text: 'Total',
          value: 't0tal',
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      dateRange: 'reports/dateRange',
      invoiceSourceReport: 'reports/invoiceSourceReport'
    })
  },
  mounted () {
    this.getInvoiceSourceReport()
  },
  methods: {
    ...mapActions({
      updateDateRange: 'reports/updateDateRange',
      getInvoiceSourceReport: 'reports/getInvoiceSourceReport'
    }),
    update () {
      this.updateDateRange(this.dateRange)
      this.getInvoiceSourceReport()
    }
  }
}
</script>
